import { SET_ERROR_LOGGING_IN, SET_LOGGING_IN } from "./actions"


export interface ILogginInState {
    loggingIn: boolean;
    errorMessage: string;
}

const initialState: ILogginInState =  {
    loggingIn: false,
    errorMessage: ""
};

export default (state:ILogginInState = initialState, action:any) => {
    let _state = { ...state };
    switch (action.type) {
        case SET_ERROR_LOGGING_IN:
            _state.errorMessage = action.value;
            _state.loggingIn = false;
            return _state;
        case SET_LOGGING_IN:
            _state.loggingIn = action.value;
            _state.errorMessage = "";
            return _state;
        default:
            return state;
    }
}
